<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet />
      <ion-tab-bar slot="bottom">
        <ion-tab-button
          tab="programs"
          href="/programs"
        >
          <ion-icon
            class="text-2xl"
            :src="programsIcon"
          />
          <ion-label class="sr-only">
            Programs
          </ion-label>
        </ion-tab-button>
        <ion-tab-button
          tab="progress"
          href="/progress"
        >
          <ion-icon
            class="text-2xl"
            :src="progressIcon"
          />
          <ion-label class="sr-only">
            Progress
          </ion-label>
        </ion-tab-button>
        <ion-tab-button
          tab="dashboard"
          href="/dashboard"
        >
          <ion-icon
            class="text-2xl"
            :icon="startIcon"
          />
          <ion-label class="sr-only">
            Start
          </ion-label>
        </ion-tab-button>
        <ion-tab-button
          tab="nutrition"
          href="/nutrition"
        >
          <ion-icon
            class="text-2xl"
            :icon="nutritionIcon"
          />
          <ion-label class="sr-only">
            Nutrition
          </ion-label>
        </ion-tab-button>
        <ion-tab-button
          tab="lessons"
          href="/lessons"
        >
          <ion-icon
            class="text-2xl"
            :icon="lessonsIcon"
          />
          <ion-label class="sr-only">
            Lessons
          </ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonIcon,
  IonLabel,
  IonPage,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from '@ionic/vue'
import startIcon from '@/assets/images/icons/design/dashboard.svg'
import lessonsIcon from '@/assets/images/icons/design/lessons.svg'
import programsIcon from '@/assets/images/icons/design/programs.svg'
import progressIcon from '@/assets/images/icons/design/progress.svg'
import nutritionIcon from '@/assets/images/icons/design/recipes.svg'
</script>

<style scoped>
ion-tab-button {
  --color-selected: var(--ion-color-selected);
  --ripple-color: var(--color-selected);
}
</style>
